import { PlanTier } from './planTiers';
/**
 * Razorpay subscription lifecycle states we persist. Copied from Razorpay's
 * vocabulary rather than invented, so an operator reading the row sees what the
 * provider dashboard shows.
 */
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    /** Created locally, checkout not completed. Never entitles a paid tier. */
    SubscriptionStatus["CREATED"] = "created";
    SubscriptionStatus["ACTIVE"] = "active";
    /** Payment failed and the provider stopped retrying. */
    SubscriptionStatus["HALTED"] = "halted";
    SubscriptionStatus["CANCELLED"] = "cancelled";
    /** Ran to the end of its billing cycles. */
    SubscriptionStatus["COMPLETED"] = "completed";
})(SubscriptionStatus || (SubscriptionStatus = {}));
/**
 * The Razorpay webhook events we act on. Anything else is acknowledged and
 * ignored — a provider adding an event must not 500 our endpoint.
 */
export var BillingWebhookEvent;
(function (BillingWebhookEvent) {
    BillingWebhookEvent["SUBSCRIPTION_ACTIVATED"] = "subscription.activated";
    BillingWebhookEvent["SUBSCRIPTION_CHARGED"] = "subscription.charged";
    BillingWebhookEvent["SUBSCRIPTION_HALTED"] = "subscription.halted";
    BillingWebhookEvent["SUBSCRIPTION_CANCELLED"] = "subscription.cancelled";
    BillingWebhookEvent["SUBSCRIPTION_COMPLETED"] = "subscription.completed";
})(BillingWebhookEvent || (BillingWebhookEvent = {}));
export const isBillingWebhookEvent = (value) => Object.values(BillingWebhookEvent).includes(value);
export const isPayablePlanTier = (tier) => tier !== PlanTier.FREE;
//# sourceMappingURL=billing.js.map